import {isPortugal, isValencia} from "./check-environment";

export const MAX_KG: number = isValencia() ? 4500 : isPortugal() ? 4000 : 5000;
export const MIN_KG: number = isValencia() || isPortugal() ? 2500 : 1000;
export const DEFAULT_KG: number = isValencia() || isPortugal() ? 3000 : 1000;

export function calcKgEach(thickness: number, width: number, length: number, numberOfSheets: number): number {
  return Math.ceil(((thickness * width * length * 7.85) / 1000000) * numberOfSheets);
}
